"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "26", height: "20", viewBox: "0 0 26 20", className: "Icon nav-notifications", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "#777", fillRule: "nonzero" },
            _react2.default.createElement("path", { d: "M8.5 7.75a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5zM8.5 9a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zM11.696 12.374c-.667-.076-1.709-.124-3.196-.124s-2.53.048-3.196.124a4.608 4.608 0 0 0-.406.061l-.092.044-.199.026c-1.818.235-3.357 2.02-3.357 3.895v1.802c0 .301.247.548.553.548h13.394a.544.544 0 0 0 .553-.548V16.4c0-1.858-1.537-3.635-3.374-3.897l-.19-.028-.084-.04a4.608 4.608 0 0 0-.406-.06zM0 16.4c0-2.485 1.987-4.817 4.447-5.135 0 0 .553-.265 4.053-.265s4.053.265 4.053.265C15.009 11.615 17 13.923 17 16.4v1.802c0 .993-.797 1.798-1.803 1.798H1.803A1.801 1.801 0 0 1 0 18.202V16.4zM19.5 9.75a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5zm0 1.25a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7z" }),
            _react2.default.createElement("path", { d: "M14.25 17.367v1.197a.19.19 0 0 0 .19.186h10.12c.106 0 .19-.084.19-.186v-1.197c0-1.317-1.1-2.61-2.485-2.839a9.917 9.917 0 0 0-.775-.135c-.63-.09-1.304-.143-1.99-.143a14.262 14.262 0 0 0-2.856.296c-1.29.201-2.394 1.502-2.394 2.82zm-1.25 0c0-1.929 1.547-3.76 3.452-4.056 0 0 1.336-.311 3.048-.311s3.048.311 3.048.311c1.906.311 3.452 2.125 3.452 4.056v1.197c0 .793-.645 1.436-1.44 1.436H14.44A1.44 1.44 0 0 1 13 18.564v-1.197z" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/nav-notifications.js
// module id = 1819
// module chunks = 0